module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-02.1@2x.cf1ba9c6.jpg";